export default __webpack_public_path__ + "static/blackcliff_slasher-770f9e2cf04d3d77da09e6adaaf8499e.png";